import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_RetirementType } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupRetirementType = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (RetirementType?.length === 0) {
      dispatch(Get_RetirementType());
    }
  }, []);

  const { RetirementType, loading, error } = useSelector(state => state.Lookup);

  const RetirementTypeOptions = RetirementType?.map((item, idx) =>
    item.list?.map(list => ({
      label: i18n.language === 'en' ? list.meaning : list.meaning2,
      value: list.lookupCode
    }))
  )[0];

  return { RetirementType, RetirementTypeOptions, loading, error };
};

export default useLookupRetirementType;
